import { useContext } from 'react'
import { AuthLayoutContext } from '../layouts/AuthLayoutContext'
import { AuthLayoutConfig } from '../types/authLayout/types'

export const useAuthLayout = (): AuthLayoutConfig => {
    const ctx = useContext(AuthLayoutContext)
    if (!ctx) throw new Error('useAuthLayout deve ser usado dentro de AuthLayoutProvider')
    return ctx
}
